import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  row: "",
  "justify-content-center": ""
}
const _hoisted_2 = { xs12: "" }
const _hoisted_3 = { class: "change" }
const _hoisted_4 = { class: "before" }
const _hoisted_5 = { class: "after" }

import { ref, computed, watch } from 'vue'
import { qEditorState } from '../stores'


export default /*@__PURE__*/_defineComponent({
  __name: 'ComparisonComponent',
  setup(__props) {

const exam = computed(() => qEditorState.exam)
const comparison = computed(() => qEditorState.comparison)

const dialog = ref(false)

watch(comparison, () => {
  if (comparison.value) {
    onSave()
  }
})

const questionComparisons = computed(() => {
  return comparison.value ? comparison.value.questionComparisons.filter((item) => !item.isSame) : []
})

const onCancel = () => {
  qEditorState.comparison = null
}

const onSave = () => {
  qEditorState.submitSave()
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialog).value = $event)),
      persistent: "",
      "max-width": "1000"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "headline" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("保存しますか?", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionComparisons.value, (questionComparison, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      wrap: "",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("label", null, "Question " + _toDisplayString(index + 1), 1 /* TEXT */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionComparison.changeLogs, (changeLog, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(changeLog.change), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(changeLog.before), 1 /* TEXT */),
                            _cache[4] || (_cache[4] = _createTextVNode(" ｰ> ", -1 /* CACHED */)),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(changeLog.after), 1 /* TEXT */)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "green-darken-1",
                  text: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onCancel()))
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("キャンセル", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_btn, {
                  color: "green-darken-1",
                  text: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onSave()))
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("保存", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}
}

})